import React, { useState, useEffect } from "react";
import "../App.scss";
import swalDialog from "../helpers/swalErrorPopup";
import { useDispatch, useSelector } from "react-redux";
import { isLoadChanger } from "../store/mainSlice";
import { updateIsHaveCreditCard } from "../store/userSlice";
import MastercardNew from "../img/svg/Mastercard_new.svg";
import { PoweredBy } from "../shared/PoweredBy";
import DeleteClientCreditCardPopup from "../shared/deleteCreditCardPopup";
import { useNavigate } from "react-router-dom";
import ConfirmPopup from "../shared/confirmPopup";
import { useTranslation } from "react-i18next";
import userAPI from "../api/userAPI";
import { isPartnerClalit } from "../store/partnerStore";

export const CardDetails = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isClalit = useSelector(isPartnerClalit);
  const mainUserParams = useSelector((state) => state.userSlice.mainUserData);
  const [last4Digit, setLast4Disgit] = useState("");
  const [deleteCardCreditPopupOpen, setDeleteCartCreditPopupOpen] = useState(false);
  const [isOpenConfirmPopup, setOpenConfirmPopup] = useState(false);

  const checkIsHasCreditCard = async () => {
    try {
      dispatch(isLoadChanger(true));

      let isHaveCreditCard = await userAPI.isClientHaveCreditCard({
        token: mainUserParams.Token,
        id: mainUserParams.ID,
        phone: mainUserParams.Phone,
      });
      if (!isHaveCreditCard?.data) {
        localStorage.setItem("isHaveUserCreditCard", false);
        navigate("/addCard");
      } else {
        if (isHaveCreditCard.data.Error !== 0) {
          throw {
            code: isHaveCreditCard.data.Error,
            mess: isHaveCreditCard.data.Message,
          };
        }

        localStorage.setItem("isHaveUserCreditCard", true);
        //TODO

        dispatch(updateIsHaveCreditCard(JSON.parse(isHaveCreditCard.data.Data).HasCreditCard));

        const parsedLast4Digit = JSON.parse(isHaveCreditCard.data.Data);

        setLast4Disgit(parsedLast4Digit.Last4Digit);
      }
      dispatch(isLoadChanger(false));
    } catch (err) {
      dispatch(isLoadChanger(false));
      swalDialog(err);
    }
  };

  useEffect(() => {
    checkIsHasCreditCard();
  }, []);

  const handleDeleteCard = async () => {
    await userAPI.saveDeleteClientCreditCard({
      token: mainUserParams.Token,
      id: mainUserParams.ID,
      phone: mainUserParams.Phone,
      saveCreditCard: false,
    });
    setDeleteCartCreditPopupOpen(false);
    setOpenConfirmPopup(true);
    checkIsHasCreditCard();
    localStorage.setItem("isHaveUserCreditCard", false);
  };

  const handleUpdateCard = () => {
    navigate("/addCard");
  };

  return (
    <div className="card-details-wrapper">
      <div className="card-details-container">
        <div className="card-details-payment-method-container">
          <div className="card-details-card-number">
            <span className="card-dots">****</span>
            <span style={{ margin: " 0 10px 0 3px" }}>{last4Digit}</span>
            <img src={MastercardNew} alt="" className="card-logo" />
          </div>
        </div>

        <div className="card-details-btns-container">
          {/* //update card */}
          <button onClick={() => handleUpdateCard()}>{t("CARD_DETAILS.UPDATE_CREDIT_CARD")}</button>
          {/* //delete card*/}
          <button onClick={() => setDeleteCartCreditPopupOpen(true)}>{t("CARD_DETAILS.DELETE_CREDIT_CARD")}</button>
        </div>
      </div>
      {isClalit && <PoweredBy />}
      <ConfirmPopup
        isOpen={isOpenConfirmPopup}
        setIsOpen={setOpenConfirmPopup}
        headerTextTop={t("CARD_DETAILS.CREDIT_CARD_DETAILS")}
        headerTextBottom={t("CARD_DETAILS.CREDIT_CARD_DELETED")}
        headerTextSubBottom={t("CARD_DETAILS.SUCCESSFULLY")}
        btnText={t("CARD_DETAILS.CLOSE")}
        marginB={"75px"}
        handleClose={() => {
          setOpenConfirmPopup(false);
        }}
      />
      <DeleteClientCreditCardPopup
        // isOpen={true}
        isOpen={deleteCardCreditPopupOpen}
        setIsOpen={setDeleteCartCreditPopupOpen}
        cancelText={t("CARD_DETAILS.CANCEL")}
        deleteText={t("CARD_DETAILS.DELETE")}
        headerText={t("CARD_DETAILS.DELETE_CREDIT_CARD_QUESTION")}
        bodyText={t("CARD_DETAILS.DELETE_CREDIT_CARD_MESSAGE")}
        handleDelete={() => handleDeleteCard(true)}
        handleCancel={() => setDeleteCartCreditPopupOpen(false)}
      />
    </div>
  );
};
